import cx from 'classnames';
import { observer } from 'mobx-react-lite';
import React from 'react';

import MessageBubble from 'pages/Assistant/components/MessageBubble';
import TypingIndicator from 'pages/Assistant/components/TypingIndicator';

import { ExpandIcon, FlixLogoMark, SendIcon } from './Icons';
import { BUDDY_TEXTS } from './texts';
import { useBuddy } from './useBuddy';

import styles from './styles.module.css';

const Buddy = observer(() => {
	const {
		isDragging,
		isOpen,
		position,
		messages,
		isLoading,
		inputValue,
		inputRef,
		messagesEndRef,
		handlePointerDown,
		handleExpandToFullView,
		handleClose,
		handleInputChange,
		handleSend,
		handleInputKeyDown,
		handleEditAndAsk,
		handleResend,
	} = useBuddy();

	const iconStyle = { bottom: position.y, right: position.x };

	return (
		<div className={styles.buddy} style={iconStyle}>
			{isOpen && (
				<div className={styles.popup} role="dialog" aria-label={BUDDY_TEXTS.name}>
					<div className={styles.popupHeader}>
						<div className={styles.popupHeaderIcon}>
							<FlixLogoMark />
						</div>
						<div>
							<div className={styles.popupHeaderTitle}>{BUDDY_TEXTS.name}</div>
							<div className={styles.popupHeaderSub}>{BUDDY_TEXTS.connected}</div>
						</div>
						<div className={styles.popupHeaderActions}>
							<button
								className={styles.headerBtn}
								type="button"
								title={BUDDY_TEXTS.openFullView}
								onClick={handleExpandToFullView}
							>
								<ExpandIcon />
							</button>
							<button
								className={styles.headerBtn}
								type="button"
								title={BUDDY_TEXTS.close}
								onClick={handleClose}
							>
								✕
							</button>
						</div>
					</div>

					<div className={styles.messages}>
						{messages.map((msg) => (
							<MessageBubble
								key={msg.id}
								msg={msg}
								onEditAndAsk={handleEditAndAsk}
								onResend={handleResend}
							/>
						))}
						{isLoading && <TypingIndicator />}
						<div ref={messagesEndRef} />
					</div>

					<div className={styles.inputRow}>
						<input
							ref={inputRef}
							className={styles.input}
							type="text"
							value={inputValue}
							placeholder={BUDDY_TEXTS.inputPlaceholder}
							disabled={isLoading}
							onChange={handleInputChange}
							onKeyDown={handleInputKeyDown}
						/>
						<button
							className={styles.sendBtn}
							type="button"
							aria-label={BUDDY_TEXTS.send}
							disabled={isLoading || !inputValue.trim()}
							onClick={() => handleSend()}
						>
							<SendIcon />
						</button>
					</div>
				</div>
			)}

			<button
				className={cx(styles.iconButton, { [styles.iconButtonDragging]: isDragging })}
				type="button"
				aria-label={isOpen ? BUDDY_TEXTS.close : BUDDY_TEXTS.name}
				onPointerDown={handlePointerDown}
			>
				<FlixLogoMark />
				<span className={styles.buddyLabel}>{BUDDY_TEXTS.name}</span>
			</button>
		</div>
	);
});

export default Buddy;
